import {
  gql 
} from "@apollo/client";

export const GET_WEDDING_ACCESSORIES = gql`
    query getWeddingAccessories {
        getWeddingAccessories {
            url
            items {
                title
                url
                imgurl
                description
                products {
                    id
                    uid
                    url_key
                    name
                    image {
                        url(type: "small_image", width: 692, height: 1016)
                    }
                    media_gallery {
                        url(type: "thumbnail", width: 90, height: 132)
                    }
                    price_range {
                        minimum_price {
                            final_price {
                                currency
                                value
                            }
                        }
                    }
                }
                position
            }
            seo_rich_snippets
        }
    }
`;

export default {
  getWeddingAccessories: GET_WEDDING_ACCESSORIES
};
